export default {
    "header": {"Flights": "Авиабилеты", "Booking Status": "Статус бронирования", "Contact": "Обращайся на"},
    "general": {
        "Back": "Обратно",
        "Close": "Закрыть ",
        "Edit": "Изменить",
        "Delete": "Удалить",
        "Send": "Отправить",
        "Cancel": "Обратно",
        "Confirm": "Подтвердить",
        "E-Mail": "Электронный адрес",
        "Example E-Mail": "andrei.ivanov@mail.ru",
        "Phone": "Телефон",
        "Update": "Обновить",
        "Error request": "Во время запроса произошла ошибка. Пожалуйста, повторите попытку.",
        "First Name": "Имя",
        "Last Name": "Фамилия",
        "Name": "Имя",
        "Example Last Name": "Например Ivanov",
        "Example First Name": "Например Andrei",
        "Mr": "Г-н",
        "Miss": "Г-жа",
        "Mrs": "Г-жа",
        "Title": "Статус",
        "Country": "Страна",
        "Date of Birth": "Дата рождения",
        "Example Address": "Улица аэродромная",
        "Address": "Адрес",
        "City": "Город",
        "Example City": "Например Кишинёв",
        "Zip Code": "Почтовый индекс",
        "Example Zip Code": "Например 2070",
        "Company Name": "Название компании",
        "Example Company Name": "ИП Конструкт",
        "Voucher": "Купон",
        "Are you sure?": "Вы уверены?",
        "Message": "Письмо",
        "Market": "Молдавия",
        "from Market": "из Молдовы",
        "to Market": "в Молдову",
        "Open": "Открыть",
        "Continue": "Продолжить",
        "and": "и",
        "Password": "Пароль",
        "Password Confirm": "Подтвердите пароль",
        "Gender": "Пол",
        "Male": "Мужской",
        "Female": "Женский",
        "Example Booking code": "Например 1A2B3C4D5E6F7G8",
        "Product": "Товар",
        "Photo credits": "Фотокредиты",
        "Example Voucher": "ПРИМЕР КОДА",
        "Company VAT": "НДС компании",
        "Example Company VAT": "GB123456789",
        "Booking Code": "Код бронирования",
        "Verify": "Проверь",
        "Your Name": "Твое имя",
        "Your E-Mail": "Твоя электронная почта",
        "Your Phone": "Твой телефон",
        "Your Message": "Твое сообщение",
        "Your Booking Code": "Твой код бронирования"
    },
    "date": {
        "January": "Январь",
        "February": "Февраль",
        "March": "Март",
        "April": "Апрель",
        "May": "Май",
        "June": "Июнь",
        "July": "Июль",
        "August": "Август",
        "September": "Сентябрь",
        "October": "October",
        "November": "Ноябрь",
        "December": "Декабрь",
        "Day": "ДД",
        "Month": "ММ",
        "Year": "ГГГГ"
    },
    "search-flight": {
        "Book Now": "Забронировать",
        "Marketing Cheapest": "Самый дешевый",
        "Marketing Quickest": "Самый быстрый",
        "Marketing Best": "Лучший вариант",
        "Load other results": "Загрузить больше результатов",
        "Departure date cant be empty": "Выберите дату вылета",
        "Select a departure": "Выберите аэропорт или город вылета",
        "Order by Best": "Сначала оптимальные",
        "Order by Price": "Сначала дешёвые",
        "oneway": "В одну сторону",
        "To": "Куда",
        "From": "Oткуда",
        "From airport": "Аэропорт отправления",
        "To airport": "Аэропорт прибытия",
        "Airport or City": "Аэропорт или город",
        "Passengers": "Пассажиры",
        "Adults": "Взрослые",
        "Adults Information": "Старше 12 лет",
        "Children Information": "От 2 до 12 лет",
        "Infants": "Младенцы",
        "Children": "Дети ",
        "Infants Information": "До 2 лет",
        "Passengers Adults": "{adults} взрослый|{adults} взрослых",
        "Passengers Total": "{passengers} пассажир|{passengers} пассажира",
        "Travelclass economy": "Эконом",
        "Travelclass first": "Первый",
        "Travelclass business": "Бизнес",
        "roundtrip": "Туда-обратно",
        "Departure": "Туда",
        "Return": "Обратно",
        "Departure Date": "Туда",
        "Return Date": "Обратно",
        "Search": "Поиск",
        "Travelclass": "Туристический класс",
        "Select a travelclass for your search": "Выберите туристический маршрут для поиска",
        "Confirm": "Подтвердить",
        "Create price alert": "подписаться на уведомления о ценах  / Следить за ценой / Подписка на цену",
        "Details": "Подробности",
        "price per passenger": "Цена на одного пассажира",
        "Continue": "Продолжить",
        "Filter Stops": "Пересадки",
        "Filters Direct Flight": "Прямой рейс",
        "Filters 1 Stop": "1 пересадка",
        "Filters 2 Stops": "2 пересадки",
        "Filter Duration": "Время в пути",
        "1 Stop": "1 пересадка",
        "2 Stops": "2 пересадки",
        "Filter Departure": "Рейс туда",
        "Filter Time Arrival": "Время прибытия",
        "Filter Time Departure": "Время вылета",
        "Filter Return": "Рейс обратно",
        "Filters": "Фильтры",
        "Filter Results": "Результаты фильтров",
        "Direct": "Прямой",
        "Filter Stop duration": "Продолжительность пересадки",
        "Travelclass premium": "Премиум-класс",
        "Invert Departure with Destination": "Изменить направление",
        "Autocomplete No Result": "Не найдено ни одного аэропорта/города",
        "Filter Carriers": "Авиакомпании",
        "Duration just h": "{hour}ч",
        "Duration just m": "{min}м",
        "Duration h and m": "{hour}ч {min}м",
        "Some suggestions based on your position": "Некоторые предложения с учетом вашей позиции",
        "Digit 3 characters and select from the list": "Наберите 3 буквы и выберите из списка",
        "Sorry no airports or city found": "К сожалению, аэропорты и города не найдены",
        "Alert Update about this route": "Получайте обновления цен для этого маршрута",
        "Activate an alert": "Активировать оповещение",
        "Send me a notification": "Отправить мне уведомление",
        "Everyday": "Ежедневно",
        "Every two days": "Каждые два дня",
        "Every three days": "Каждые три дня",
        "Every five days": "Каждые пять дней",
        "Every week": "Еженедельно",
        "Every two weeks": "Каждые две недели",
        "Details Flight": "Информация о рейсе",
        "Details Flights": "Информация о рейсах",
        "Order by Duration": "По длительности поездки",
        "Different airport": "Рейс туда приземляется в {arrival}, а обратный рейс вылетает из {departure}.",
        "Stop segment just h": "Остановка {hour}h",
        "Stop segment just m": "Остановка {min}м",
        "Stop segment h and m": "Остановка {hour}h {min}м",
        "No Results Second Row": "похоже, что нет рейсов",
        "No Results Third Row": "доступен",
        "No Results Filters First Row": "О нет!",
        "No Results Filters Second Row": "похоже, что нет рейсов",
        "No Results First Row": "О нет!",
        "No Results Filters Third Row": "доступен",
        "Alternative next_departure_day": "Вылет на следующий день",
        "Alternative next_return_day": "Обратно на следующий день",
        "Alternative closer_departure": "Вылет в ближайший аэропорт",
        "Alternative closer_destination": "Прибытие в ближайший аэропорт",
        "Alternative different_route": "Другие аэропорты",
        "Alternative different_days": "Другой день",
        "Alternative different_day": "Другие даты",
        "Segment 1": "Прямой рейс",
        "Segment 2": "1 пересадка",
        "Segment 3": "2 пересадки",
        "Segment 4": "3 пересадки",
        "All flights": "Все рейсы",
        "Filter Price Range": "Диапазон цен",
        "Remove some filter to have more results": "Удалите некоторые фильтры, чтобы получить больше результатов",
        "No Results Filter First Row": "Нет результатов",
        "No Results Filter Second Row": "настроены текущие фильтры",
        "No Results Filter Third Row": "Удалите некоторые фильтры или измените дату поездки",
        "Plus 1 day": "+1 день",
        "Plus X days": "+{days} дня",
        "Departure date": "Дата вылета",
        "Return date": "Дата возвращения",
        "Edit": "Изменить",
        "Filter results": "Результаты фильтрации",
        "Back on top": "Обратно вверх",
        "Best solution": "Лучший вариант",
        "Cheapest": "Самый дешевый",
        "Fastest": "Самый быстрый",
        "Order by": "Сортировка",
        "Price Alert": "Следить за ценой",
        "Price Calendar": "Календарь цен",
        "Calendar": "Календарь",
        "Prices starting at price": "Цены от {price}",
        "Order by Departure Hour": "По времени вылета",
        "Order by Arrival Hour": "По времени прилёта",
        "Departure Hour": "Время вылета",
        "Arrival Hour": "Время прибытия",
        "Long stop info": "Длинная пересадка",
        "Short stop info": "Это короткая пересадка",
        "Deactivate alert": "Отключить оповещение",
        "Deactivate Alert about this route": "Вы уверены, что хотите отключить оповещение для этого поиска?",
        "Alert is now deactivated": "Оповещение отключено",
        "Overnight stops": "Ночнaя пересадка",
        "Destinations from city": "Рейсы из {departure}",
        "Prices indicated map": "Ориентировочные цены на одного пассажира",
        "Prices approximated": "Цены указаны на одного пассажира. Некоторые цены указаны приблизительно и будут пересчитаны при выборе пункта назначения.",
        "Popularity": "Популярные",
        "Combination with multiple companies": "Все компании",
        "Order by Popularity": "Сортировать по популярности",
        "Further": "Далее",
        "Order by Further": "Сортировать по Далее",
        "Closest": "Ближайший",
        "Order by Closest": "Сортировать по степени близости",
        "Departure and destination same": "Пункт отправления и пункт назначения не могут быть одним и тем же",
        "Updated X": "Обновлено {when}",
        "Departure Airports": "Аэропорты вылета",
        "Destination Airports": "Аэропорты назначения",
        "Filters Any Stop": "Любая остановка",
        "Outward": "Туда",
        "Filters 3 Stops": "3 пересадки",
        "3 Stops": "3 пересадки",
        "You can try to choose an alternative search": "Повторите поиск, используя другие параметры",
        "Filter Times": "Время отправления ",
        "Filter Airports": "Аэропорты",
        "Select all": "Выбрать все",
        "Deselect all": "Очистить все",
        "Airline Only": "Только",
        "Next Day": "Следующий день",
        "Previous Day": "Предыдущий день",
        "Arrival in X": "Прибытие в {airport}",
        "Stay X nights": "{nights} ночь в {destination}|{nights} ночей в {destination}",
        "Stop segment just m in airport": "Остановка {min}м в {airport}",
        "Stop segment h and m in airport": "Остановка {hour}ч {min}м в {airport}",
        "Stop segment just h in airport": "Остановка {hour}h в {airport}",
        "Anywhere": "Куда угодно",
        "Show results containing this flight": "Показать результаты, содержащие этот полет",
        "Number results": "{results} полеты",
        "Passengers & Class": "Пассажиры и класс",
        "Outbound Flights": "Исходящие рейсы",
        "Inbound Flights": "Входящие рейсы",
        "final price without commission": "Стоимость проезда для одного пассажира | Стоимость проезда для {n_pax} пассажиров",
        "final price": "окончательная цена",
        "price per passenger without commission": "цена за одного пассажира + {commission} налога на услуги",
        "final price without commission amount": "Тариф для одного пассажира + {commission} налога на услуги | Тариф для {n_pax} пассажиров + {commission} налога на услуги",
        "Duration": "Продолжительность",
        "Order": "Сортировка",
        "Loading results": "Мы ищем свободные места в более чем 400 авиакомпаниях"
    },
    "range": {
        "From Minutes To Minutes": "От {0} до {1}",
        "From Time To Time": "С {0} до {1}",
        "From": "От",
        "To": "до"
    },
    "filter": {"departure": "Рейс туда", "return": "Рейс обратно"},
    "duration": {
        "just h": "{hour}ч",
        "h and m": "{hour}ч {min}м",
        "just m": "{min}м",
        "Just m": "{min}м",
        "Just h": "{hour}ч"
    },
    "features": {
        "Clear Prices": "Прозрачные  цены",
        "Clear Prices description": "Мы отображаем самые низкие цены без скрытых комиссий.",
        "Exclusive routes": "Умный маршрут",
        "Exclusive routes description": "Мы объединяем различные авиакомпании и маршруты, чтобы предложить вам большой выбор решений и самые низкие цены на рынке.",
        "Best support": "Служба поддержки клиентов",
        "Best support description": "Мы отвечаем на телефонные звонки и на электронные письма. Вы можете выбрать самый удобный для вас метод связаться с нами.",
        "Security": "Безопасность данных",
        "Security description": "Сайт защищен лучшими технологиями и безопасен в использовании.",
        "Exclusive Combinations": "Эксклюзивные комбинации",
        "Exclusive Combinations description": "Все авиакомпании, все тарифы, эксклюзивные комбинации, составленные Any Flight"
    },
    "alert": {
        "Receive alert": "Получать оповещение",
        "Daily": "Ежедневно",
        "Weekly": "Еженедельно",
        "Every Two Weeks": "Каждые две недели",
        "Alert is now active": "Ваш запрос был успешно выполнен. Теперь оповещение активно."
    },
    "booking": {
        "Booking": "Книга",
        "Card holder": "Имя и фамилия владельца карты",
        "Example Card holder": "Например Andrei Ivanov",
        "Expiration": "Срок действия (ММ/ГГ)",
        "You will be redirected to Coinbase page to complete the payment": "Чтобы завершить вашу покупку с криптовалютой, вы будете перенаправлены на платежную платформу Coinbase, где сможете выбрать из различных безопасных и надежных криптовалют.",
        "Next step": "Следующий шаг: {step}",
        "Taxes and fees included": "Налоги и сборы включены",
        "Booking Expired": "Бронирование истекло",
        "Booking is Expiring": "Срок действия бронирования истекает",
        "Booking Expired Message": "К сожалению, время для завершения бронирования истекло, и нам необходимо повторно подтвердить результаты поиска.",
        "Booking Is Expiring Message": "Время для завершения бронирования истекает. Пожалуйста, завершите бронирование как можно скорее.",
        "Remaining time": "<b>Оставшееся время:</b> {time}",
        "Complete the form to book": "Заполните форму и забронируйте свой рейс!",
        "Title non refundable": "Невозвратный билет",
        "Title refundable": "Частично возвратный",
        "Debit or Credit Card": "Дебетовая или кредитная карта",
        "Info not refundable": "Если вы захотите отменить этот билет после его приобретения, авиакомпания не вернет вам уплаченную сумму.",
        "Info refundable": "Если вы захотите отменить этот билет после его покупки, авиакомпания вернет вам оставшуюся сумму после вычета всех соответствующих штрафов и прочих кассовых сборов, если таковые имеются.",
        "Flight conditions": "Условия билета",
        "Not selected": "Не выбрано",
        "No priority boarding": "Нет приоритетной посадки",
        "Priority boarding": "Приоритетная посадка",
        "Cabin luggage": "Багаж на борту",
        "We are checking the price for the chosen trip": "Подтверждаем цену",
        "We are working out the final quote for your trip": "Вскоре вы сможете ввести данные пассажиров, и выбрать дополнительные услуги, если они доступны.",
        "Flight from X to Y": "Перелет из {departure} в {destination}",
        "Marketing Best Price": "Вы нашли <b>лучшую цену для перелёта в {destination}</b>",
        "Marketing Best Duration": "Вы нашли <b>самый короткий перелет в {destination}</b>",
        "Marketing Best Price 10": "Вы нашли <b>самый дешевый перелет в {destination}</b>",
        "Marketing Best Price 20": "Вы нашли <b> перелет в {destination} по хорошей цене</b>",
        "Marketing Best Duration 10": "Вы нашли <b>самый быстрый перелет в {destination}</b>",
        "Marketing Best Duration 20": "Вы нашли <b>короткий рейс в {destination}</b>",
        "Marketing 1 Interested": "Один человек заинтересован в этой поездке",
        "Marketing More Interested": " <b>{count} заинтересованы</b> в этой поездке",
        "Contact Details": "Контактные данные",
        "Lead Passenger": "Ведущий пассажир",
        "X Passenger": "Пассажир {count}",
        "At least one adult is required": "Требуется как минимум один взрослый",
        "adult": "Взрослый",
        "infant": "Младенец",
        "child": "Ребенок",
        "Title": "Статус",
        "Hold Luggage": "Сдаваемый багаж",
        "Hold Luggage section": "Сдаваемый багаж",
        "Hand Luggage": "Большая ручная кладь",
        "Hand Luggage section": "Ручная кладь",
        "Select option luggage": "Выберите опцию сдаваемого багажа:",
        "Add Passenger": "Добавить пассажира",
        "Continue": "Продолжить",
        "Update type customer to adult": "Мы изменили тип пассажира на взрослый",
        "Update type customer to child": "Мы изменили тип пассажира на ребенка",
        "Update type customer to infant": "Мы изменили тип пассажира на младенца",
        "Error too many infants": "Вы не можете разместить в одной резервации только младенцев и затем взрослых.",
        "Error too many passengers": "Вы не можете иметь более 9 пассажиров в одном бронировании",
        "Error at least a 16 is required": "Требуется как минимум один пассажир в возрасте от 16 лет",
        "Additional services": "Дополнительные услуги",
        "Automatic Check-In": "Check&Go",
        "Automatic Check-In Info": "Мы вышлем вам посадочный талон по электронной почте. Вот так просто! Без хлопот и всегда вовремя к вашему рейсу.",
        "Travel Insurance": "Туристическое страхование",
        "Travel Insurance Info": "Туристическое страхование",
        "Luggage Insurance": "Страхование багажа",
        "Luggage Insurance Info": "Всего одна страховка покрывает все багажи одного пассажира. В случае задержки вашего багажа на 96 часов она выплатит вам 1000 евро.",
        "Disruption Protection": "Компенсация за рейс",
        "Disruption Protection Info": "В случае сбоев в работе по вине авиакомпании вы получите компенсацию в размере до 600 евро на пассажира.",
        "Provided by Name": "предоставлено по {name}",
        "Terms and conditions": "Правила и условия",
        "Passengers": "Пассажиры",
        "Summary and payment": "Обзор и оплата",
        "Contacts": "Контакты",
        "Personal": "Личный",
        "Company": "Компания",
        "Billing data": "Личные данные",
        "Voucher code": "Промокод",
        "Credit Card": "Кредитная карта",
        "Card number": "Номер карты",
        "Card Holder": "Владелец карты",
        "We are processing the payment": "Мы обрабатываем платеж",
        "This operation will last just some seconds": "Эта процедура продлится всего несколько секунд",
        "Retry payment": "Повторный платеж",
        "An error occurred during the elaboration of your payment": "Во время разработки вашего платежа произошла ошибка:",
        "Order complete": "Заказ #{internal_code} выполнен",
        "Your order is now complete": "Ваш заказ завершен, вы должны были получить подтверждение по электронной почте и SMS.",
        "Confirmation order": "Максимум за 24 часа вы получите",
        "adults": "Взрослые",
        "Price details": "Детали стоимости",
        "Includes commission": "Включает комиссию",
        "Total": "Итого",
        "Price changed": "Стоимость вашего бронирования изменилась",
        "Aircompany increased price of reservation": "К сожалению, авиакомпании только что изменили стоимость Вашего бронирования.",
        "CVC": "CVC",
        "Cvv": "Код безопасности",
        "Old price": "Старая цена",
        "New price": "Новая цена",
        "Accept current price": "Принять текущую цену",
        "Or you can select an alternative": "Или вы можете выбрать другой вариант",
        "Show all results": "Показать все результаты",
        "No luggage": "Без сдаваемого багажа",
        "Boarding priority included": "Приоритетная посадка включенo",
        "Small luggage": "Маленькая ручная кладь",
        "Luggage": "Багаж",
        "Free": "Бесплатно",
        "Single Luggage": "1 Сдаваемый багаж",
        "Multiple Luggage": "{count} Сдаваемых багажа",
        "Single Hand Luggage": "1 Ручная кладь",
        "Multiple Hand Luggage": "{count} Ручных кладей",
        "Single Priority boarding": "1 Приоритетная посадка",
        "Multiple Priority boarding": "{count} Приоритетные посадки",
        "All information related to this passenger will be removed": "Вся информация, связанная с этим пассажиром, будет удалена.",
        "Add check-in": "Добавить Check&Go за {price} на каждого пассажира",
        "No check-in": "Мне не нужна автоматическая регистрация",
        "Add insurance per day": "{price} за сутки",
        "Add insurance": "{price} всего",
        "Compensation of": "Компенсация в размере {amount}",
        "Add per passenger": "Добавить за {price} за пассажира",
        "Flight Disruption": "Защита от сбоев",
        "Flight Compensation": "Компенсация за рейс",
        "Short stop": "Информация о короткой остановке",
        "Long stop": "Информация о длинной остановке",
        "Small personal item": "Небольшой личный предмет",
        "Show only some options": "Показать только некоторые варианты",
        "Show all options": "Показать все варианты",
        "Payment": "Оплата",
        "Discount": "Скидка",
        "Select passenger": "Выбрать пассажира",
        "Payment was made": "Оплата в размере {amount} была осуществлена через {payment}.",
        "Booking code": "Код бронирования",
        "Complete purchasing": "Завершение покупки",
        "Accept terms and conditions": "Я прочитал и принимаю правила и условия, условия Smart Bundle и договор обслуживания",
        "Accept receive messages": "Я хочу получать бесплатные ваучеры, сделки и лучшие предложения",
        "Tracking and delivery of luggage": "Отслеживание и доставка багажа в течение 96 часов",
        "Compensation of x in case": "Компенсация в размере {amount} в случае потери багажа более чем на 96 часов",
        "No need of proofs": "Не нужны доказательства",
        "No insurance": "Без страховки",
        "Share on Facebook": "Поделиться в Facebook",
        "Share on Twitter": "Поделиться в Twitter",
        "Download image": "Скачать изображение",
        "Share on Whatsapp": "Поделиться в Whatsapp",
        "Fare rule": "Правила тарифа",
        "Credit Card Visa/Mastercard": "Кредитная карта Visa/Mastercard",
        "American Express": "American Express",
        "Pay using your credit or debit card Visa or Mastercard": "Оплатите с помощью кредитной или дебетовой карты Visa или Mastercard",
        "Pay using your credit or debit card American Express": "Оплатите с помощью кредитной или дебетовой карты American Express",
        "Pay using your credit or debit card": "Оплатите с помощью кредитной или дебетовой карты Visa, Mastercard или American Express",
        "Cryptocurrencies": "Криптовалюты",
        "Pay using your Bitcoin, Bitcoin Cash, Dai, Dodge coin, Etherum or USD Coin wallet": "Оплачивайте с помощью кошелька Bitcoin, Bitcoin Cash, Dai, Dodge coin, Etherum или USD Coin",
        "Terms & Conditions": "Правила и условия",
        "Small Luggage": "Маленькая ручная кладь",
        "Priority": "Приоритетная посадка",
        "Just bought my ticket to city": "Только что купил билет на <u>#{city}</u>",
        "Just bought my ticket to city plain": "Только что купил билет на #{city} #ninjatrip",
        "Payment information": "Платежи на нашем сайте защищены высочайшей технологией SSL.",
        "Operated by": "Выполняет {aircompany}",
        "No hold luggage": "Без сдаваемого багажа",
        "Warning": "Внимание",
        "Exclusive solution made by Ninja Trip": "Это эксклюзивное решение создано компанией Ninja Trip. Оно включает различные рейсы от одной или нескольких авиакомпаний, которые обычно не продаются вместе.",
        "Exclusive solution made by Ninja Trip 2": "Это эксклюзивное решение создано компанией Ninja Trip.",
        "If you have hold luggage you need to collect it and recheck it": "Если у вас есть регистрируемый багаж, вам необходимо забрать его и зарегистрировать.",
        "In case of cancellation of one segment, there can’t be a refund on the remaining flights": "В случае отмены одного сегмента, возврат денег за оставшиеся рейсы невозможен.",
        "In case of delay you may miss the connecting flight and the company may not reprotect you on another flight": "В случае задержки вы можете опоздать на стыковочный рейс, и компания не сможет пересадить вас на другой рейс. В том числе, если авиакомпания одна и та же.",
        "Select option hold luggage": "Выберите подходящий вариант регистрируемого багажа:",
        "I dont want this service": "Мне не нужна эта услуга",
        "Select option hand luggage": "Выберите подходящий вариант ручной клади:",
        "In some airports there isn’t a “connection” path and you may need to redo the security checks and it may be required a visa": "В некоторых аэропортах нет пути \"стыковки\", и вам, возможно, придется заново проходить контроль безопасности, а также может потребоваться виза.",
        "All luggage includes": "Весь багаж включается",
        "If you are travelling hold luggage you need to collect your luggage and re-check it": "Если у вас есть сдаваемый багаж, вы должны забрать его и сдать снова при регистрации на следующий рейс. ",
        "Transfer to airport": "Самостоятельный трансфер в {airport}\n",
        "Flight cancellation message": "Компенсация до 600 евро в случае отмены рейса.",
        "Flight delayed message": "До 600 евро компенсации в случае задержки рейса более, чем на 3 часа.",
        "Flight overbooking message": "Компенсация до 600 евро в случае овербукинга. ",
        "departure": "Рейс туда ",
        "return": "Рейс обратно ",
        "infants": "Младенцы",
        "children": "Дети",
        "Included in the price": "Включено в стоимость",
        "Copy from Passenger": "копировать данные пассажиров",
        "Total Price": "Итого",
        "Step Search": "Поиск рейсов",
        "Step Passengers": "Пассажиры",
        "Step Additional Services": "Дополнительные услуги",
        "Step Summary and Payment": "Обзор и оплата",
        "Step Complete": "Полный",
        "Back to Search Results": "Назад к результатам поиска",
        "1 Hold Luggage": "1 Сдаваемый багаж",
        "X Hold Luggage": "{count} Сдаваемых багажа",
        "per passenger": "за пассажира",
        "Automatic Check-In In your EMail": "Посадочный талон  <b>отправлен на указанный вами электронный адрес</b>",
        "Automatic Check-In Terms": "Нажав кнопку добавить, вы принимаете <a href=\"{link}\" target=\"_blank\">правила и условия</a>",
        "Only X price": "только {price}",
        "Your data are encrypted and safe": "Ваши данные зашифрованы и надежно защищены",
        "You can pay with": "Принимаемые валюты",
        "Summary": "Обзор",
        "Add service": "Добавить услугу",
        "Remove service": "Удалить услугу",
        "Remove Passenger": "Удалить пассажира",
        "Hold Luggage information": "Зарегистрированный багаж перевозится только в багажном отделении, может содержать жидкости и должен быть сдан на стойке аэропорта перед вылетом.",
        "Hand Luggage information": "Ручная кладь может быть взята на борт самолета, может содержать жидкости не более 100 мл и имеет ограничение по размеру и весу.",
        "Booking Details": "Подробности бронирования",
        "Select": "Выбрать",
        "Terms auto accepted": "Завершая заказ, я подтверждаю, что прочитал и принял <a href=\"{link}\" target=\"_blank\">правила и условия, условия Smart Bundle и договор обслуживания</a>.",
        "Disruption Protection Terms": "Услуга предоставлена Trouble Flight, нажав кнопку добавить, вы принимаете <a href=\"{link}\" target=\"_blank\">правила и условия</a>",
        "Luggage Insurance Terms": "Услуга предоставлена Blue Ribbon Bags, нажав кнопку добавить, вы принимаете <a href=\"{link}\" target=\"_blank\">правила и условия</a>",
        "Automatic Check-In On Time": "Регистрация <b>на рейс всегда вовремя</b> без аэропортовых сборов",
        "Passenger": "Пассажир",
        "You need to collect your luggage and re-check it": "Вы должны забрать багаж и снова предъявить его при регистрации на рейс",
        "kg": "кг.",
        "Price per passenger": "{price} за одного пассажира",
        "Loading booking": "Мы уточняем цену у авиакомпании.",
        "This page is 100% safe": "Эта страница на 100% безопасна",
        "Secure": "Безопасная страница",
        "Safe transmission data": "Твои личные данные защищены безопасной передачей и зашифрованным хранением.",
        "Info CVV": "Cvv/cvc2 обычно находится на обратной стороне карты и состоит из трех цифр. В примере 123.",
        "Info Expiration": "Дата окончания срока действия обычно расположена на лицевой стороне карты. Она состоит из месяца и года. В примере 10/28.",
        "Rush Message": "Чем больше ты ждешь, тем выше тариф! Забронируй его сейчас и сэкономь на цене.",
        "Small Hand Luggage section": "Маленький ручной багаж",
        "Subtotal": "Промежуточный итог",
        "Taxes and fees excluded": "Налоги и сборы исключены",
        "Service and Administration Taxes": "Налоги на услуги и административные расходы",
        "Select your baggage": "Выберите свой багаж",
        "Personal baggage": "Личный багаж",
        "Hand baggage": "Ручная кладь",
        "Included": "В комплекте",
        "Small Hand Luggage information short": "Небольшой багаж, который можно уместить под сиденьем перед твоим креслом.",
        "Hand Luggage information short": "Ручная кладь, которая помещается в шкафчик над сиденьем.",
        "No Hand Luggage": "Никакой ручной клади",
        "Includes also priority boarding for": "Включает в себя также приоритетную посадку для",
        "Small Hand Luggage information": "Небольшая ручная кладь может быть взята на борт, может содержать жидкости не более 100 мл, имеет ограничение по размеру и весу и должна быть расположена обязательно под передним сиденьем или сверху, если нет свободного места.",
        "1 Hand Luggage": "1 Ручная кладь",
        "X Hand Luggage": "{count} Ручная кладь",
        "Hold baggage": "Удерживайте багаж",
        "Hold Luggage information short": "Холд-багаж перевозится только в холде, он будет сдан на стойке аэропорта перед вылетом.",
        "No Hold Luggage": "Без багажа",
        "Call us info": "У тебя есть вопрос? Позвони нам",
        "Automatic Check-In Short Description": "Получи посадочный талон на свой рейс по электронной почте",
        "Automatic Check-In Description": "На твою электронную почту, всегда вовремя",
        "Disruption Protection Short Description": "До 600 евро в случае задержки, отмены или перебронирования",
        "Disruption Protection Description": "Никаких комиссий, 100% возврат денег",
        "Track your lost luggage": "Отслеживай потерянный багаж",
        "Track your lost luggage Short Description": "Найди свой потерянный багаж или получи 1000 евро компенсации",
        "Track your lost luggage Description": "Сервис от Blue Ribbon Bags",
        "Payment Card": "Карта",
        "Payment Crypto": "Криптовалюта",
        "Payment Wallet": "Кошелек",
        "Complete purchasing on X": "Заверши покупку на {supplier}",
        "After submission, you will be redirected to supplier to complete next steps": "После отправки ты будешь перенаправлен на сайт {supplier} для выполнения следующих шагов.",
        "Thank you for your order!": "Спасибо за твой заказ!",
        "The order confirmation has been sent to your email address": "Подтверждение заказа было отправлено на твой электронный адрес",
        "Payment of AMOUNT accepted": "Оплата в размере {amount} принята",
        "Booking Status": "Статус бронирования",
        "Remove": "Удалить"
    },
    "booking-errors": {
        "payment_intent_authentication_failure": "Платеж не прошел, пожалуйста, повторите попытку",
        "expired_card": "Используемая карта больше не действительна.",
        "processing_error": "Ошибка в процессе оплаты",
        "incorrect_cvc": "CVC/CC2 вашей карты неправильный.",
        "Generic error": "Стандартная ошибка",
        "unsupported_card": "Банк больше не поддерживает выплаты на эту карту.",
        "no_account": "Вероятно, реквизиты банковского счета в файле неверны. По этим реквизитам невозможно найти банковский счет.",
        "invalid_currency": "Банк не смог обработать эту выплату из-за ее валюты. Возможно, это связано с тем, что банковский счет не может принимать платежи в этой валюте.",
        "incorrect_account_holder_tax_id": "Ваш банк уведомил нас о том, что ИНН владельца банковского счета в файле неверен.",
        "incorrect_account_holder_address": "Ваш банк уведомил нас о том, что адрес владельца банковского счета в файле неверен.",
        "incorrect_account_holder_name": "Ваш банк уведомил нас о том, что имя владельца банковского счета в файле неверно.",
        "invalid_account_number": "Номер банковского счета при переводе кажется правильным, но номер счета недействителен.",
        "insufficient_funds": "На вашем счете Stripe недостаточно средств для выплаты.",
        "card_declined": "Банк отклонил этот перевод. Пожалуйста, свяжитесь с банком перед повторной попыткой.",
        "account_closed": "Банковский счет был закрыт.",
        "account_frozen": "Банковский счет был заморожен.",
        "bank_account_restricted": "Банковский счет имеет ограничения либо по виду, либо по количеству разрешенных выплат.",
        "bank_ownership_changed": "Счет в банке назначения больше не действителен, поскольку его филиал сменил владельца.",
        "could_not_process": "Банк не смог обработать эту выплату.",
        "debit_not_authorized": "Дебетовые операции не утверждаются на банковском счете."
    },
    "seo-flights-to": {
        "City Airports": "{to} аэропорты",
        "City has one airport": "{to} есть только один аэропорт: {airports}.",
        "Title": "Дешевые авиабилеты в {to}",
        "City has more airports": "{to} имеет {count} аэропортов: {airports}.",
        "Find cheap flight": "Найдите дешевые авиабилеты в {to} Аэропорт с Ninja Trip. Бронировать авиабилеты с Ninja Trip просто, быстро и, самое главное, бесплатно!",
        "Compare cheap flights": "Сравните дешевые рейсы в {to} Аэропорт, просто воспользовавшись поисковой строкой выше. Результаты поиска покажут вам самый широкий спектр авиакомпаний и туристических агентов, предлагающих дешевые авиабилеты в {to} Аэропорт. А затем вы можете просто забронировать свои рейсы в {to} Аэропорт напрямую, перейдя на сайты агентств или авиакомпаний. ",
        "Chart cheap flights": "Если ваши даты поездки гибкие, Ninja Trip покажет вам самые дешевые дни в месяце для перелета в {to} Аэропорт, наши графики покажут Вам самое лучшее время для перелета в {to} Аэропорт чтобы вы действительно могли найти дешевый рейс.",
        "What airlines": "Какие авиакомпании летают в {to} {market}?",
        "Number of airlines": "Множество авиакомпаний предлагают прямые и непрямые рейсы в {to} {market}, часто ежедневные, включая {airlines}.",
        "Find cheap flights 2": "Найдите лучшее предложение по дешевым рейсам в {to} с Ninja Trip. Минимальная цена перелета в Ninja Trip с {market} составляет {min_price}, но стоимость перелета зависит от количества свободных мест, день(ей) в который(ые) вы путешествуете, и время когда вы бронируете.",
        "Bookmark cheap flights": "Если вы нашли выгодную цену на авиабилеты в аэропорт {to}, то добавьте Ninja Trip в закладки и возвращайтесь чтобы бесплатно искать и бронировать билеты на рейсы сотен авиакомпаний и в тысячи пунктов назначения по всему миру.",
        "Seo Description No Price": "Ищете рейсы в {to} Аэропорт? Сравните авиакомпании и бюджетные авиакомпании для дешевых рейсов в аэропорт {to}. Ищите и экономьте прямо сейчас с Ninja Trip.",
        "Seo Title No Price": "Дешевые авиабилеты в аэропорт {to} ({to_code}) - Авиабилеты",
        "Seo Description": "Ищете рейсы в {to} Аэропорт? Сравните авиакомпании и бюджетные авиакомпании для дешевых рейсов в аэропорт {to}. Ищите и экономьте прямо сейчас с Ninja Trip.",
        "Prices for flights from market to destination": "Цены на рейсы {market} в {to}",
        "Seo Title": "Дешёвые авиабилеты в аэропорт {to} ({to_code}) от {min_price} - Авиабилеты",
        "Alt image index": "Рейсы в {to} - Фото {index}",
        "Title ru-md": "рейсы в {to}",
        "Title ro-md": "Zboruri către {to}",
        "Title ru-ru": "рейсы в {to}",
        "Title ro-ro": "Zboruri către {to}",
        "Title es-es": "Vuelos a {to}",
        "Title en-us": "Flights to {to}",
        "Title en-gb": "Flights to {to}",
        "Title it-it": "Voli per {to}",
        "Related Airlines": "Авиакомпании, которые летают в {to}"
    },
    "seo-flights-from": {"Flights from": "Рейсы из {from}"},
    "seo-flight": {"Flight from to": "Перелет из {from} в {to}", "Flight to": "Полет в {to}"},
    "seo-aircompany": {
        "Company information": "{aircompany} информация",
        "Average price": "Средняя стоимость",
        "Most popular destination": "Самое популярное направление",
        "Weekly flights": "Еженедельные рейсы",
        "Country": "Страна",
        "Title": "Рейсы {aircompany}",
        "Title en-gb": "{aircompany} Flights",
        "Title en-us": "{aircompany} Flights",
        "Title ro-ro": "Zboruri {aircompany}",
        "Title ro-md": "Zboruri {aircompany}",
        "Title ru-ru": "Рейсы {aircompany}",
        "Title es-es": "Vuelos {aircompany}",
        "Title it-it": "Voli {aircompany}",
        "Title ru-md": "Рейсы {aircompany}",
        "Title from": "{aircompany} Авиабилеты всего от {price}",
        "Seo Title": "Дешевые {aircompany} Авиабилеты - NinjaTrip",
        "Seo Title with Price": "{aircompany}  Авиабилеты всего от {min_price} - NinjaTrip",
        "Alt image index": "{aircompany} Авиарейсы - Фото {index}",
        "Seo Description": "Сравните лучшие рейсы с {aircompany}. Ищите и экономьте прямо сейчас с Ninja Trip.",
        "Seo Description No Price": "Сравните лучшие рейсы с {aircompany}. Ищите и экономьте прямо сейчас с Ninja Trip.",
        "Air Companies": "Авиационные компании"
    },
    "share": {
        "Copy": "Копировать",
        "Share link offer": "Поделитесь ссылкой",
        "Link copied": "Ссылка была скопирована, вы можете отправить ее своим друзьям",
        "Share this offer": "Поделитесь этим предложением",
        "Share flight": "Посмотри на этот рейс!"
    },
    "footer": {
        "International Websites": "Наши веб-сайты",
        "Other destinations": "Другие направления",
        "Follow us": "Присоединяйтесь к нам",
        "Ninja Trip": "Ninja Trip",
        "About Us": "О нас",
        "Why Us": "Почему именно мы",
        "Media Room": "Медиатека",
        "Work with us": "Работайте с нами",
        "Advertising": "Реклама",
        "Affiliation": "Партнерство",
        "Copyright": "© {year} Все права защищены. RO44531870 GTM Global Travel Management S.R.L. Услуги, предоставляемые через сайт, предлагаются агентством GTM или его партнерами.",
        "Iata Accredited Agency": "Аккредитованное агентство Iata",
        "Airlines": "Авиакомпании",
        "Destinations": "Направления",
        "Routes": "Маршруты",
        "Reservations": "Бронирования",
        "Support": "Поддержка",
        "Follow us description": "Оставайся с нами и получай доступ к последним предложениям и скидкам:",
        'Any Flight': 'Any Flight'
    },
    "support": {
        "Support center": "Центр поддержки",
        "Warning flights": "Предупредительные полеты",
        "Incident is effecting flights in country": "Инцидент отражается на полетах в {country}",
        "Incident is effecting flights with aircompany": "Инцидент влияет на рейсы {aircompany}",
        "Incident is effecting flights at airport": "Инцидент влияет на рейсы в аэропорт {airport}",
        "Incident airline_system_failure": "Технические проблемы аэропорта",
        "Incident airport_staff_strike": "Забастовка сотрудников аэропорта",
        "Incident atc_and_other_airline": "Забастовка авиадиспетчеров",
        "Incident aircraft_incidents": "Инцидент с самолетом",
        "Incident volcano_eruptions": "Вулканические извержения",
        "Incident thunderstorms": "Гроза",
        "Incident snowstorm": "Снежная буря",
        "Incident terrostic_alert": "Террористическое предупреждение",
        "Incident war": "Военный конфликт",
        "Incident bomb_alert": "Предупреждение о бомбе",
        "Incident political_unrest": "Политические беспорядки",
        "Incident floodings": "Наводнение",
        "Incident earthquakes": "Землетрясения",
        "Incident airline_bankruptcy": "Банкротство авиакомпании",
        "Incident airline_strike": "Забастовка сотрудников авиакомпаний",
        "Incident covid19": "Ограничения по Ковид 19",
        "Incident airport_incident": "Инцидент в аэропорту",
        "Incident airport_blackout": "Отключение электроэнергии в аэропорту",
        "Incident disclamer": "Данный список не является полным, вся представленная информация не имеет юридической силы и может быть интерпретирована только как предложение.",
        "Contact us": "Свяжитесь с нами",
        "Send request": "Отправить запрос",
        "Your request was sent": "Ваш запрос был отправлен. Мы ответим на него как можно скорее.",
        "Support": "Поддержка",
        "Incident atc_and_other_airline-related_bodies": "Забастовка авиадиспетчера или другого сотрудника аэропорта",
        "Search on support center": "Поиск по Центру поддержки",
        "Example Search": "Напишите что-нибудь вроде \"регистрация\".",
        "Search": "Поиск",
        "Most common problems": "Самые распространенные проблемы",
        "Contact Us": "Свяжитесь с нами",
        "Search for X": "Поиск по \"{keyword}\"",
        "No articles found": "Не найдено записей",
        "Not related to a reservation": "Не связано с бронированием",
        "No ID available": "ID отсутствует",
        "Booking Information": "Информация о бронировании",
        "Message start": "Здравствуй команда Ninja Trip, Спасибо",
        "Problem": "Проблема",
        "Request": "Запрос",
        "Send Request": "Отправить запрос",
        "Thank you for your request": "Спасибо за ваш запрос!",
        "We will answer you via E-Mail on email as soon as possible": "Мы ответим вам по электронной почте на {email} в ближайшее время.",
        "Create an account and use all the perks!": "Создайте личный кабинет и используйте все преимущества!",
        "Fill passengers details once, use it every time": "Заполните данные пассажиров один раз и используйте при каждом бронировании.",
        "One click to fill and download the invoice": "Заполняйте и скачивайте инвойсы легко и быстро.",
        "Keep track of your trips and tickets": "Отслеживайте свои билеты и поездки.",
        "Automatic check-in or follow easy steps explained to print your boarding pass": "Доступ к автоматической регистрации или к инструкциям для самостоятельной регистрации.",
        "Cant find what you are looking for": "Не можете найти что-то?",
        "Get support from Ninja Trip": "Получите поддержку от Ninja Trip",
        "Example Message": "Пример сообщения",
        "Contact us description": "Мы здесь, чтобы помочь тебе. Свяжись с нами по электронной почте или через форму онлайн."
    },
    "validation": {
        "Accept terms error": "Мы не сможем оформить ваш заказ, если вы не согласны с нашими условиями предоставления услуг.",
        "Password not safe enought": "Пароль недостаточно безопасен",
        "Please use only latin letters": "Пожалуйста, используйте только латинские буквы.",
        "The credit card field is required": "Номер кредитной карты обязателен",
        "The security code is required": "Код безопасности обязателен",
        "The expiration data is required": "Необходимо указать срок действия кредитной карты",
        "phone_invalid": "Номер телефона недействителен"
    },
    "seo-flights-route": {
        "Title": "Дешевые авиабилеты из {from} в {to}\n",
        "Seo Description": "Найдите и забронируйте авиабилеты из {from} в {to} в одну сторону или туда и обратно по лучшей цене. Найдите лучшие предложения и скидки. Ninja Trip имеет лучшую службу поддержки в туристической индустрии.",
        "Chart Title": "Рейсы в оба конца из {from} в {to}",
        "Trip duration (days)": "Длительность поездки (days)",
        "How many airports in x": "Сколько всего аэропортов в {city}?",
        "Just airport of X with name": "В {city}: {name} есть только один аэропорт.",
        "Just airport of X no name": "В {city} есть только один аэропорт.",
        "There are X airports in X": "В {city}: {airports} есть {count} аэропорта.",
        "How long does it take to fly from X to Y": "Сколько времени занимает перелет из {departure} в {destination}?",
        "The average flight time is hr and mins": "Среднее время полета составляет {hour} час {minutes} минут.",
        "The average flight time is hrs and mins": "Среднее время полета составляет {hour} часа {minutes} минут.",
        "The average flight time is hrs": "Среднее время полета составляет {hour} часов.",
        "The average flight time is hr": "Среднее время полета составляет {hour} час.",
        "The average flight time is mins": "Среднее время полета составляет {minutes} минут.",
        "Which aircompanies offer direct flights from X to Y": "Какие авиакомпании предлагают прямой рейс из {departure} в {destination}?",
        "No direct flights": "К сожалению, нет компаний, предлагающих прямой перелет из  {departure} в {destination}.",
        "Only one direct company": "Только одна авиакомпания предлагает прямой перелет из  {departure} в {destination}: {aircompanies}.",
        "Many direct company": "{count} авиакомпаний предлагают прямой рейс из {departure} в {destination}: {aircompanies}.",
        "What is the cheapest time to buy a ticket for a flight from X to Y": "В какое время дешевле всего покупать билет на самолет из {departure} в {destination}?",
        "What is the price for a flight from X to Y": "Какова цена перелета из {departure} в {destination}?",
        "The cheapest price is X": "Самая низкая цена за перелет из {departure} в {destination} составляет {price}.",
        "The cheapest price both is X Y": "Самые низкие цены на перелет из {departure} в {destination}  - {price_oneway} для рейса в одну сторону и {price_roundtrip} для рейса туда и обратно.",
        "The cheapest price roundtrip is X": "Самая дешевая цена перелета туда и обратно из {departure} в {destination} составляет {price}.",
        "The cheapest price oneway is X": "Самая низкая цена за перелет из {departure} в {destination} составляет {price}.",
        "No indication price": "В настоящее время у нас нет обновленной статистики, сделайте поиск на нашем сайте, чтобы узнать цены в режиме реального времени.",
        "Right now we have no indication about the best time to travel from X to Y": "На данный момент у нас нет информации о лучшем времени для путешествия из {departure} в {destination}.",
        "Best moment to travel from X to Y is the month of Z": "Основываясь на нашей информации, самым экономичным месяцем для перелета из {departure} в {destination} является {month}.",
        "Closest airport from X are": "По прямой линии, ближайшие аэропорты к {airport} находятся {airports}.",
        "What airports are there near x": "Какие аэропорты находятся поблизости от {city}?",
        "Related airlines": "Связанные авиалинии",
        "Aircompany link": "Рейсы {aircompany} в {destination}",
        "Flight Departure Title": "Рейсы из {city}",
        "Flight Destination Title": "Рейсы в {city}",
        "Some prices of flights from X to Y": "Некоторые цены на перелеты из {from} в {to}",
        "Title anchor": "Рейсы {from} - {to}",
        "Title en-gb": "Flights from {from} to {to}",
        "Title en-us": "Flights from {from} to {to}",
        "Title it-it": "Voli da {from} a {to}",
        "Title es-es": "Vuelos de {from} a {to}",
        "Title ro-ro": "Zboruri de la {from} către {to}",
        "Title ro-md": "Zboruri de la {from} către {to}",
        "Title ru-ru": "Рейсы {from} - {to}",
        "Title ru-md": "Рейсы {from} - {to}",
        "Reverse trip": "Обратная поездка",
        "Seo Title": "Дешевые авиабилеты из {from} в {to} аэропорт - {from_code} {to_code} - Авиабилеты"
    },
    "checkin": {
        "Complete missing data for Check-In": "Заполните отсутствующие данные для регистрации",
        "Instruction Fill Check-In": "Для завершения регистрации необходимо предоставить некоторые дополнительные данные. Во избежание задержек, пожалуйста, заполните недостающую информацию как можно скорее, чтобы мы могли завершить вашу регистрацию и отправить ее вам сразу же, как только она будет доступна.",
        "Check-in closed": "Регистрация закрыта",
        "Instruction Check-In Closed": "Мы сожалеем, но регистрация для вашего бронирования уже закрыта.",
        "passport": "Паспорт",
        "identity_card": "Удостоверение личности",
        "Document type": "Вид документа",
        "Example Document Number": "АГ123456",
        "Document number": "Номер документа",
        "Date of emission": "Дата выброса",
        "Date of expiration": "Дата выдачи",
        "Legal info": "Нажимая кнопку \"Продолжить\", я под свою ответственность подтверждаю, что все введенные данные верны и что мне известны правила о продуктах запрещенных на борту.",
        "Check-In is already completed": "Мы уже получили информацию чтобы иметь возможность провести вашу регистрацию.",
        "Check-In Completed": "Благодарим вас за заполнение всей необходимой для регистрации информации.",
        "Check-In When sent": "Мы вышлем вам регистрацию за несколько дней до вылета, исходя из правил авиакомпании.",
        "Passport": "Паспорт",
        "Identity Card": "Удостоверение личности\n",
        "Instructions": "Запиши имя и фамилию точно так же, как в паспорте/идентификационной карте, иначе тебе могут отказать. В случае если у тебя есть второе имя, впиши его в первое."
    },
    "partner": {
        "Service offered by Trouble Flight": "Предлагаемые компанией Trouble Flight услуги",
        "This service is offered by a partner of Ninja Trip": "Эта услуга предлагается партнером Ninja Trip.",
        "To speed up the claim process, we can share your booking data with Trouble Flight": "Чтобы ускорить процесс рассмотрения заявки, мы можем передать данные о вашем бронировании компании Trouble Flight.",
        "This information includes": "Эта информация включает:",
        "Passenger names": "Имена пассажиров",
        "Itinerary booked": "Забронированный маршрут",
        "Booking code": "Код бронирования",
        "E-mail address and telephone number": "Адрес электронной почты и номер телефона",
        "Continue": "Продолжить",
        "Terms": "Нажимая кнопку продолжить, вы разрешаете Ninja Trip (GTM - Global Travel Management S.R.L.) отправить информацию о вашем бронировании в Trouble Flight (Doorify Tech S.R.L.). Trouble Flight будет использовать эту информацию только для ускорения создания заявки. После нажатия кнопки вы будете перенаправлены на веб-сайт Trouble Flight, где вы сможете заполнить свою заявку."
    },
    "job": {
        "Click to upload your CV": "Нажмите, чтобы загрузить свое резюме",
        "Curriculum vitae": "Резюме",
        "Candidate for X": "Кандидат на должность \"{role}\"",
        "Candidate for this role": "Кандидат на эту должность",
        "X Candidates": "{n} кандидатов",
        "Full time role": "Работа на полную ставку"
    },
    "myaccount": {
        "My upcoming trips": "Мои планируемые поездки",
        "Flight roundtrip from to": "Перелет в оба конца из {departure} в {destination}",
        "Flight oneway from to": "Перелет в один конец из {departure} в {destination}",
        "Checkin opens in date": "Регистрация открывается",
        "Checkin is currently open": "В настоящее время регистрация открыта",
        "Check In Instructions": "Инструкции по регистрации",
        "Check In Instructions details": "Для того чтобы путешествовать, вам необходим посадочный талон. Ниже вы найдете инструкции о том как загрузить их для всех компаний в вашем путешествии",
        "CheckIn warning": "В случае нескольких PNR вам необходимо повторить процедуру один раз для каждого PNR.",
        "Check in will open x and close y": "Регистрация открывается <b>{open}</b> и закрывается <b>{close}</b> перед вылетом.",
        "Start Check-In": "Начать регистрацию",
        "Check-In": "Регистрация",
        "Invoice": "Счет-фактура",
        "Download invoice X": "Скачать счет-фактуру {series}{number}",
        "Sign up via E-Mail": "Зарегистрироваться по электронной почте",
        "Use another account": "Используйте другую учетную запись",
        "Sign up": "Зарегистрироваться",
        "Passengers": "Пассажиры",
        "No Passengers First Row": "Все еще",
        "No Passengers Second Row": "пассажиров здесь нет,",
        "No Passengers Third Row": "добавьте первого пассажира и сэкономьте время при бронировании",
        "Add Passenger": "Добавить пассажира",
        "Edit": "Редактировать",
        "Edit Profile": "Редактировать профиль",
        "Edit Password": "Редактировать пароль",
        "Your trip is being confirmed": "В ближайшее время вы получите бронирование",
        "No trips": "Поездка не доступна...",
        "Details": "Подробности",
        "All reservations": "Все бронирования",
        "Future reservations": "Будущие бронирования",
        "Past reservations": "Прошлые бронирования",
        "See": "Смотреть",
        "My trips": "Мои поездки",
        "Prev page": "« Назад",
        "Next page": "Далее »",
        "Support": "Поддержка",
        "Product flight": "Рейс"
    },
    "upload": {
        "Single file only": "На рассмотрение принимается только один файл.",
        "File uploaded correctly": "Файл загружен правильно",
        "X files uploaded correctly": "{n_files} файлов загружены правильно"
    },
    "login": {
        "Login": "Вход",
        "Instruction Login Sign in": "Войти в Ninja Trip или",
        "Instruction Login Create an account": "создать аккаунт",
        "Continue with social": "Продолжить с {social}",
        "My Account": "Моя учетная запись",
        "Logout": "Выход из системы",
        "Hello name": "Здравствуйте {name}",
        "Instruction Login Register": "Давайте создадим для вас новую учетную запись!",
        "Instruction Login Password": "Введите пароль вашей учетной записи Ninja Trip",
        "Go back": "или вернуться",
        "Hello": "Здравствуйте",
        "Accept Terms and Conditions": "Я прочитал и согласен с Правилами и условиями, Политикой конфиденциальности.",
        "Offers": "Я хочу получать самые выгодные предложения.",
        "Forgotten password": "Забыл пароль",
        "Welcome": "Добро пожаловать",
        "Instruction Login Reset Password": "Выберите новый безопасный пароль",
        "Sent link password": "Мы отправили письмо со ссылкой для сброса пароля на указанный адрес электронной почты",
        "The link is no longer valid": "Ссылка больше не действительна. Вероятно, прошло слишком много времени и она истекла.",
        "E-Mail or password wrong": "Неверный адрес электронной почты или пароль",
        "Confirm E-Mail change": "Подтвердите изменение электронной почты",
        "Profile edited correctly": "Профиль отредактирован правильно",
        "Current Password": "Текущий пароль",
        "Password changed correctly": "Пароль изменен правильно",
        "Your session is expired": "Ваша сессия истекла, войдите снова чтобы продолжить"
    },
    "seo-flights-to-country": {
        "Some prices of flights from X to Y": "Некоторые цены на перелеты {from} в {to}\n",
        "Some prices same country to Y": "Некоторые цены на авиабилеты в {to}",
        "How long does it take to fly X to Y": "Сколько времени лететь из {departure} в {destination}?",
        "The average flight time is hr and mins": "Если рассматривать перелет из {airport_departure} в {airport_destination}, то среднее время перелета составляет {hour} час {minutes} минут.",
        "The average flight time is hrs and mins": "Если рассматривать перелет из {airport_departure} в {airport_destination}, то среднее время перелета составляет {hour} часа {minutes} минут.",
        "The average flight time is hrs": "Если рассматривать перелет из {airport_departure} в {airport_destination}, то среднее время перелета составляет {hour} часа.",
        "The average flight time is hr": "Если рассматривать перелет из {airport_departure} в {airport_destination}, то среднее время перелета составляет {hour} час.",
        "The average flight time is mins": "Если рассматривать перелет из {airport_departure} в {airport_destination}, то среднее время перелета составляет {minutes} минут.",
        "What is the price for a flight X to Y": "Сколько стоит перелет {departure} до {destination}?",
        "Cheapest price same outward roundtrip": "Самая низкая цена на перелет {departure} в {destination} составляет для билета в одну сторону из {city_departure} в {city_destination} {price_oneway}, а для билета туда и обратно {price_roundtrip}.",
        "Cheapest price different outward roundtrip": "Самая низкая цена на авиабилеты {departure} в {destination}: для перелета в одну сторону из {city_departure_oneway} в {city_destination_oneway} {price_oneway} и {price_roundtrip} для перелета туда-обратно из {city_departure_roundtrip} в {city_destination_roundtrip}.",
        "Cheapest price roundtrip": "Самая низкая цена на перелет {departure} в {destination} составляет {price} за перелет туда и обратно из {city_departure} в {city_destination}.",
        "Cheapest price oneway": "Самая низкая цена на рейс {departure} в {destination} составляет {price} за перелет в одну сторону из {city_departure} в {city_destination}.",
        "Which aircompanies flights X to Y": "Какие авиакомпании выполняют рейсы {departure} в {destination}?",
        "Which aircompanies flights direct X to Y": "Какие авиакомпании выполняют прямые рейсы {departure} в {destination}?",
        "No airlines": "В настоящий момент у нас нет информации об авиакомпаниях, выполняющих рейсы {departure} в {destination}.",
        "No airlines direct": "В настоящий момент у нас нет информации об авиакомпаниях, выполняющих прямые рейсы {departure} в {destination}.",
        "Only one company": "Одна авиакомпания выполняет рейсы {departure} в {destination}: {aircompanies}.",
        "Only one company direct": "Одна авиакомпания выполняет прямые рейсы {departure} в {destination}: {aircompanies}.",
        "Many companies": "Авиакомпании, выполняющие рейсы из {departure} в {destination}, - это {авиакомпании}.",
        "Many companies direct": "Авиакомпании, выполняющие прямые рейсы {departure} в {destination}, - это {aircompanies}.",
        "Most popular airline": "Самая популярная авиакомпания",
        "Cheapest price": "Самая дешевая цена",
        "Airports in X": "Аэропорты в {country}",
        "Airport link": "Рейсы в {destination}",
        "Title": "Рейсы в {destination}",
        "Subtitle": "Лететь в {destination}"
    },
    "home": {"Popular Destinations": "Популярные направления", "Home": "Дом"},
    "booking-status": {
        "Find Booking": "Найти бронирование",
        "Processing your booking": "Обработка твоего бронирования...",
        "We are processing your booking request Please wait": "Мы обрабатываем твой запрос на бронирование. Пожалуйста, подожди",
        "Booking Code": "Бронирование: {code}",
        "Booking completed": "Бронирование завершено",
        "Thank you for your booking": "Спасибо тебе за бронирование!",
        "Booking refused": "Отказано в бронировании",
        "We are sorry, but your booking cannot be confirmed": "Нам очень жаль, но твоя бронь не может быть подтверждена. Твоя оплата была возвращена.",
        "Payment": "Оплата",
        "Payment Method": "Способ оплаты",
        "Payment Amount": "Сумма оплаты"
    },
    "seo": {
        "Airlines": "Авиакомпании",
        "Air Companies": "Авиационные компании",
        "List of Airlines": "Список авиакомпаний",
        "Searches": "Поиски",
        "Flights to X": "Полеты на {to}",
        "Some X Flights": "Некоторые рейсы {aircompany}",
        "Find the cheapest time to fly to X": "Найди самое дешевое время для перелета в {to}"
    }
};